import { render } from "./SignIn.vue?vue&type=template&id=35471218&scoped=true"
import script from "./SignIn.vue?vue&type=script&lang=js"
export * from "./SignIn.vue?vue&type=script&lang=js"

import "./SignIn.vue?vue&type=style&index=0&id=35471218&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Michael.Mathu\\Documents\\Projects\\unique_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35471218"]])

export default __exports__